<template>
  <div class="totalSolve-container">
    <div class="totalSolve-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/total-solution-banner-fix.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">智慧图书馆整体解决方案</h2>
          <p class="banner-desc">
            博库公共图书馆智慧化建设方案充分利用物联网、移动互联网、云计算、人工智能等新兴技术
          </p>
          <p class="banner-desc">
            从图书馆的管理、服务、空间、馆舍四个维度建设智慧型的图书馆
          </p>
          <p class="banner-desc">
            帮助图书馆提高服务的高效性和知识的共享性，增强读者的借阅体验
          </p>
          <p class="banner-desc">最大限度提升图书馆公共服务效能</p>
        </div>
      </div>
    </div>
    <!-- 整体解决方案 -->
    <div class="totalSolve-container-solution">
      <h2 class="totalSolve-container-solution-title title-common">
        整体解决方案
      </h2>
      <ul class="totalSolve-container-solution-list">
        <li v-for="(item, i) in solutionList" :key="i">
          <div class="totalSolve-container-solution-list-pic">
            <img :src="item.src" alt="" />
          </div>
          <i>{{ item.picDesc }}</i>
          <p>{{ item.desc1 }}</p>
          <p>{{ item.desc2 }}</p>
          <p>{{ item.desc3 }}</p>
        </li>
      </ul>
      <div class="totalSolve-container-solution-word">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-word.png"
          alt=""
        />
      </div>
    </div>
    <!-- 方案特点 -->
    <div class="totalSolve-container-feature">
      <h2 class="totalSolve-container-feature-title title-common">方案特点</h2>

      <ul class="totalSolve-container-feature-list">
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-feature1.png"
            alt=""
          />
          <h3>紧跟新时代新技术</h3>
          <p>时刻掌握新技术实现场景落地应用</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-feature2.png"
            alt=""
          />
          <h3>顺应新政策新趋势</h3>
          <p>时刻相应政策导向引领行业趋势发展</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-feature3.png"
            alt=""
          />
          <h3>聚焦新需求新痛点</h3>
          <p>不断发现客户潜在需求和痛点</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-feature4.png"
            alt=""
          />
          <h3>打造新产品新理念</h3>
          <p>不断打造全新产品提出全新升级概念</p>
        </li>
      </ul>
    </div>
    <!-- 新技术新应用 -->
    <div class="totalSolve-container-newTechnique">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-newTec.png"
        alt=""
      />
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      solutionList: [
        {
          src:
            "https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-item1.png",
          picDesc: "管理智慧化",
          desc1: "书籍流通和管理",
          desc2: "智能人流管控",
          desc3: "空间预约系统",
        },
        {
          src:
            "https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-item2.png",
          picDesc: "服务智慧化",
          desc1: "自助服务",
          desc2: "泛在服务",
          desc3: "个性化服务",
        },
        {
          src:
            "https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-item3.png",
          picDesc: "空间智慧化",
          desc1: "数字阅读空间",
          desc2: "互动体验空间",
          desc3: "泛在图书馆",
        },
        {
          src:
            "https://image.bookgo.com.cn/bgOfficial/totalSolve/totalSolve-item4.png",
          picDesc: "馆舍智慧化",
          desc1: "图书馆物联网管理系统",
          desc2: "智能wifi",
          desc3: "智慧机房",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libTotalsolve.scss";
</style>
